module.exports = __webpack_public_path__ + "background3.jpg";